var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2307 6.77167L13.2274 7.76833L3.41236 17.5833H2.41569V16.5867L12.2307 6.77167ZM16.1307 0.25C15.8599 0.25 15.5782 0.358333 15.3724 0.564167L13.3899 2.54667L17.4524 6.60917L19.4349 4.62667C19.8574 4.20417 19.8574 3.52167 19.4349 3.09917L16.8999 0.564167C16.6832 0.3475 16.4124 0.25 16.1307 0.25ZM12.2307 3.70583L0.249023 15.6875V19.75H4.31152L16.2932 7.76833L12.2307 3.70583Z",
    fill: "#1D5E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.44b1f13a1b07d843a5274a55b15d405c.svg";
export { ForwardRef as ReactComponent };